<template>
  <div class="sion-personnel chose_dept" v-loading.fullscreen.lock="loading">
  <div class="sino-panel">

    <div class="panel-top">
      <el-input
          placeholder="请输入关键字搜索"
          @input="searchFn"
          v-model="seachVal">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>

      <div class="dept_ctns" style="background:#fff" ref="deptCtn" v-if="depentOpention&&depentOpention.length">
        <!-- <div v-for="(item,index) in depentOpention" :key="item.id" @click="deptClick(item,index)" :class="item.id==id?'active_dept':''">
          {{item.name}}
        </div> -->
          <VanCheckboxGroup v-model="checkboxGroup3">
            <van-checkbox v-for="item in depentOpention" :name="item.id" :key="item.id">{{item.name}}</van-checkbox>
          </VanCheckboxGroup>
      </div>
      <!-- 没数据时 -->
      <div class="blank" v-if="!depentOpention.length&&!loading">
        <img src="@/images/404-02.png" alt>
      </div>
      <div class="confirmBtn" @click="confirmDept">确定</div>
   </div>
  </div>
</template>
<script type="text/ecmascript-6">
import { toast } from "@/common/api/api.js";
export default {
  data() {
    return {
     depentOpention:[],//科室list
     seachVal:'',//
     loading:true,
     id:'',
     checkboxGroup3:[],
     checkedDeptArr:[],
     arr:[]
    };
  },
  created() {
  },
   watch: {
    seachVal(value) {
      if (!value) {
        this.getDeptList();
      }
    }
  },
  mounted(){
    const {id} = this.$route.query;
    this.checkboxGroup3 = id
    this.getDeptList();
  },
  methods: {
    //点击确定
    confirmDept(){
      console.log(this.checkboxGroup3)
      this.checkboxGroup3.forEach((v,i)=>{
        this.depentOpention.forEach((item,index)=>{
          if(v==item.id){
            this.checkedDeptArr.push(item)
          }
        })
      })
      // console.log('22',this.checkedDeptArr)
      sessionStorage.setItem("chosedDept",JSON.stringify(this.checkedDeptArr));
      this.$router.go(-1);
    },
    searchFn(){
      // 模糊查询
      if(this.seachVal){
        let arr = [];
        this.depentOpention&&this.depentOpention.length&&this.depentOpention.forEach(item=>{
          if(item.name.indexOf(this.seachVal)!=-1)arr.push(item);
        })
        this.depentOpention=arr;
      }
      
    },
    getDeptList() {
      var that = this;
      this.centralControl.axios.centralControl(
        "findLeaderAndDeptList",
        (res) => {
          this.loading=false;
          const { code, data, message } = res;
          if (code == 200) {
            //赋值科室
            that.depentOpention = data.officeList;
            let _index = that.depentOpention.length&&that.depentOpention.findIndex(item=>{return item.id==that.id})
            if(_index>=0){
               this.$nextTick(()=>{
                  this.$refs.deptCtn.scrollTop=46*_index;
               })
            }
          }
        },
        {}
      );
    },
    update(){
      this.$nextTick(()=>{
        let _index = this.depentOpention.length&&this.depentOpention.findIndex(item=>{return item.id==this.id})
        console.log(_index,46*_index,this.$refs.deptCtn)
        if(_index>=0)this.$refs.deptCtn.scrollTop=46*_index;
      })
    }
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus">
.chose_dept{
  background: #FFF;
  /deep/ .el-checkbox{
    height:35px;
    line-height:35px;
    padding:0 20px;
    border-bottom:1px solid #eee;
  }
  /deep/ .el-checkbox-group{
    padding-top:0;
  }
  /deep/ .van-checkbox{
  height:40px;
  line-height:40px;
  text-align:center;
  border-bottom:1px solid #eee;

}
/deep/ .van-checkbox-group{
  padding:10px 20px 80px 20px;

}
/deep/ .van-checkbox__icon--checked .van-icon{
  background-color:#29BDBB !important;
  border-color:#29BDBB !important;
}
/deep/ .van-checkbox__label{
  color:#888 !important;
}

  // /deep/ .el-checkbox__inner{
  //   display:none;
  // }
  .confirmBtn{
    width:115px;
    height:40px;
    background:#29BEBC;
    color:#fff;
    text-align center;
    line-height:40px;
    position:fixed;
    bottom:5px;
    left:35%;
    border-radius:20px;
  }
  .panel-top input {
    height: 35px !important;
    border: none;
  }
  .panel-top .el-input__icon {
    line-height: 36px;
  }
  .dept_ctn {
    height: calc(100vh - 1.573333rem);
    overflow-y: scroll;
    background: #FFF;
    div {
      padding: 10px 0 70px 0;
      font-size: 14px;
      border-bottom 1px solid #EFEFF4;
      // display:flex;
      // flex-direction:column;
     
    }
 
  }
  .el-checkbox__input.is-checked .el-checkbox__inner{
    background-color: #29BEBC;
    border-color: #29BEBC;
  }
  .el-checkbox__input.is-checked+.el-checkbox__label{
    color: #29BEBC;
  }
  .active_dept {
    color: #29BEBC
  }
}
</style>